export default __webpack_public_path__ + "static/media/cat.2c4252e4.svg";